import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from '../User.scss';
import groupsStyles from './UserGroupList.scss';
import icons from 'styles/icons/icons.scss';
import { Link } from 'react-router';


export class UserGroupList extends Component {

    getGroupPath(group) {
        const path = `/admin/groups/${group.id}`;
        return path;
    }

    getGroupsPath() {
        const { user } = this.props;
        const path = `/admin/groups?q=${user.displayName}`;
        return path;
    }

    render() {
        const { groups } = this.props;

        return (
            <div className={styles.container} data-cy="UserGroupList">
                <header className={styles.header}>
                    <div className={styles.icon}>
                        <span className={icons.materialIcons}>people_outline</span>
                    </div>
                    <Link className={styles.title} to={this.getGroupsPath()}>Groups</Link>
                </header>
                <div className={groupsStyles.groupsTable}>
                    <header className={groupsStyles.tableRow + ' ' + groupsStyles.tableRowHeader}>
                        <div className={groupsStyles.wrapper}>
                            <div className={groupsStyles.text}>
                                Name
                            </div>
                        </div>
                        <div className={groupsStyles.wrapper}>
                            <div className={groupsStyles.description}>
                                Description
                            </div>
                        </div>
                    </header>
                    { groups.map((group, index) => {
                        return (
                            <Link key={index} to={this.getGroupPath(group)} data-cy={'UserGroupList' + index}>
                                <div className={groupsStyles.tableRow}>
                                    <div className={groupsStyles.wrapper}>
                                        <div className={groupsStyles.text} data-cy={'displayName-UserGroupList' + index}>
                                            { group.displayName }
                                        </div>
                                    </div>
                                    <div className={groupsStyles.wrapper}>
                                        <div className={groupsStyles.description} data-cy={'description-UserGroupList' + index}>
                                            { group.description }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    }

}

UserGroupList.propTypes = {
    groups: PropTypes.array.isRequired
};

export default UserGroupList;
